import angular from 'angular';
import referrerComparison from './referrerComparison';
import './style.scss';

export default angular
  .module('components.referrerComparison', [])
  .component('referrerComparison', referrerComparison).name;
